import _defineProperty from '@babel/runtime/helpers/defineProperty';

var MANAGE_PAYMENT_PAGE = 'manage-payment-page';
var MAKE_PAYMENT_PAGE = 'make-payment-page';
var CONTRACT_SUMMARY_PAGE = 'contract-summary-page';
var ACCOUNT_EVENT = 'account';
var LABEL_FIN_AGREEMENT = 'financial-agreement';
var LABEL_FIN_AGREEMENT_MANAGE_PAYMENT = 'financial-agreement-manage-payment';
var LABEL_FIN_AGREEMENT_MAKE_PAYMENT = 'financial-agreement-make-payment';
var makeGAEvent = function makeGAEvent(event, label) {
  return function (interaction) {
    return {
      event: event,
      interaction: interaction,
      label: label
    };
  };
};
var makeFinAgreementEvent = makeGAEvent(ACCOUNT_EVENT, LABEL_FIN_AGREEMENT);
var CONTRACT_SUMMARY_PAGE_GA_EVENT = {
  MANAGE_PAYMENT: makeFinAgreementEvent('manage-payment'),
  MAKE_PAYMENT: makeFinAgreementEvent('make-payment'),
  CHANGE_PAYMENT: makeFinAgreementEvent('change-payment'),
  CHANGE_PAYMENT_SUCCESS: makeFinAgreementEvent('change-payment-success'),
  FINANCIAL_TERMS: makeFinAgreementEvent('financial-terms'),
  PAYMENT_HISTORY: makeFinAgreementEvent('payment-history'),
  BILLING_DETAILS: makeFinAgreementEvent('billing-details'),
  DOWNLOAD_LEASE_AGREEMENT: makeFinAgreementEvent('download-lease-agreement')
};
var makeFinAgreementManagePaymentEvent = makeGAEvent(ACCOUNT_EVENT, LABEL_FIN_AGREEMENT_MANAGE_PAYMENT);
var MANAGE_PAYMENT_PAGE_GA_EVENT = {
  CHANGE_PAYMENT: makeFinAgreementManagePaymentEvent('change-payment'),
  CHANGE_PAYMENT_SUCCESS: makeFinAgreementManagePaymentEvent('change-payment-success'),
  CHANGE_BILLING_ADDRESS: makeFinAgreementManagePaymentEvent('change-billing-address'),
  CHANGE_BILLING_ADDRESS_SUCCESS: makeFinAgreementManagePaymentEvent('change-billing-address-success')
};
var makeFinAgreementMakePaymentEvent = makeGAEvent(ACCOUNT_EVENT, LABEL_FIN_AGREEMENT_MAKE_PAYMENT);
var MAKE_PAYMENT_PAGE_GA_EVENT = {
  CHANGE_PAYMENT: makeFinAgreementMakePaymentEvent('change-payment'),
  CHANGE_PAYMENT_SUCCESS: makeFinAgreementMakePaymentEvent('change-payment'),
  CHANGE_BILLING_ADDRESS: makeFinAgreementMakePaymentEvent('change-payment'),
  CHANGE_BILLING_ADDRESS_SUCCESS: makeFinAgreementMakePaymentEvent('change-payment'),
  PAYMENT_COMPLETE: makeFinAgreementMakePaymentEvent('change-payment')
};
var mapPageToGaEvents = _defineProperty(_defineProperty(_defineProperty({}, MANAGE_PAYMENT_PAGE, MANAGE_PAYMENT_PAGE_GA_EVENT), CONTRACT_SUMMARY_PAGE, CONTRACT_SUMMARY_PAGE_GA_EVENT), MAKE_PAYMENT_PAGE, MAKE_PAYMENT_PAGE_GA_EVENT);

export { CONTRACT_SUMMARY_PAGE, MAKE_PAYMENT_PAGE, MANAGE_PAYMENT_PAGE, mapPageToGaEvents };
